import type { JSX } from 'react';

import { cx } from '@emotion/css';
import { AccountHolderAddressDto } from 'src/dtos';
import { ClientServicesLink, MTypography } from 'src/lib';

import { Font, Spacing } from '../styles';

export const renderAddressMismatchErrorMessage = ({
  address,
  onClick,
  section,
}: {
  address: AccountHolderAddressDto;
  onClick: () => void;
  section: string;
}): JSX.Element => {
  const { address1, address2, city, state, postalCode } = address;
  const addressString = [address1, address2, city, state, postalCode].filter(Boolean).join(', ');

  return (
    <MTypography variant='body1' testId={`${section.replace(' ', '-')}-invalid-address-section`}>
      Invalid {section} address. USPS found the following address: <br />
      {addressString}. <br />
      If the address is correct, please click{' '}
      <a onClick={onClick} className={cx(Spacing.p4, Font.lg)}>
        here
      </a>{' '}
      to update the form.
    </MTypography>
  );
};

export const renderAddressNotFoundErrorMessage = (): JSX.Element => (
  <MTypography variant='body1' testId={`usps-address-not-found-section`}>
    Invalid address. USPS did not find address as it does not contain a valid combination of City, State and Postal
    Code. Please contact <ClientServicesLink /> to resolve. You will not be able to &quot;Save&quot; or Complete this
    application until address is resolved.
  </MTypography>
);

export const renderNetworkErrorMessage = (): JSX.Element => (
  <MTypography variant='body1'>
    There was an error connecting to the server. Please make sure that your Internet connection is stable and try again.
    If the problem persists, please try refreshing the page or contact <ClientServicesLink />.
  </MTypography>
);

export const renderUnknownErrorMessage = (value: any): JSX.Element => {
  if (value?.message) {
    return (
      <MTypography variant='body1'>
        Unknown error occurred (error: {value.message}). Please try again later. If the problem persists, please contact{' '}
        <ClientServicesLink /> to resolve.
      </MTypography>
    );
  }

  return (
    <MTypography variant='body1'>
      Unknown error occurred(error: {value}). Please try again later or contact <ClientServicesLink /> to resolve.
    </MTypography>
  );
};

export const renderCreateAccountMaximumAttemptsExceededErrorMessage = (): JSX.Element => (
  <MTypography variant='body1'>
    You have reached the maximum number of failed account creation attempts. Please contact <ClientServicesLink /> to
    find out more information.
  </MTypography>
);

export const renderLinkAccountMaximumAttemptsExceededErrorMessage = (): JSX.Element => (
  <MTypography variant='body1'>
    You have reached the maximum number of failed account linking attempts. Unfortunately, we could not link your new
    account. Please contact <ClientServicesLink /> to find out more information.
  </MTypography>
);
